import Icon from '@/components/ui/AppIcon';

interface ContactMethod {
  id: string;
  icon: string;
  title: string;
  description: string;
  value: string;
  action: string;
  availability: string;
  responseTime: string;
}

const contactMethods: ContactMethod[] = [
  {
    id: '1',
    icon: 'PhoneIcon',
    title: 'Phone Support',
    description: 'Speak directly with our technical experts for immediate assistance',
    value: '+966 55 2258277',
    action: 'Call Now',
    availability: '24/7 Available',
    responseTime: 'Immediate'
  },
  {
    id: '2',
    icon: 'ChatBubbleLeftRightIcon',
    title: 'Live Chat',
    description: 'Connect with our support team through real-time messaging',
    value: 'Start Chat',
    action: 'Chat Now',
    availability: '24/7 Available',
    responseTime: '&lt;2 minutes'
  },
  {
    id: '3',
    icon: 'EnvelopeIcon',
    title: 'Email Support',
    description: 'Send detailed inquiries and receive comprehensive responses',
    value: 'info@centronics.com.sa',
    action: 'Send Email',
    availability: 'Monitored 24/7',
    responseTime: '&lt;4 hours'
  },
  {
    id: '4',
    icon: 'CalendarIcon',
    title: 'Schedule Meeting',
    description: 'Book a consultation with our IT strategists at your convenience',
    value: 'View Calendar',
    action: 'Book Now',
    availability: 'Mon-Fri 9AM-6PM',
    responseTime: 'Same day'
  }
];

export default function ContactMethods() {
  return (
    <section className="py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-headline font-bold text-3xl lg:text-4xl text-primary mb-4">
            Choose Your Preferred Contact Method
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto">
            We offer multiple ways to connect with our team. Select the option that works best for your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {contactMethods.map((method) => (
            <div
              key={method.id}
              className="bg-card rounded-lg border border-border p-6 hover:shadow-elevated transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex flex-col h-full">
                {/* Icon */}
                <div className="w-12 h-12 bg-gradient-to-br from-brand-primary to-brand-secondary rounded-lg flex items-center justify-center mb-4">
                  <Icon name={method.icon as any} size={24} className="text-white" />
                </div>

                {/* Title */}
                <h3 className="font-headline font-bold text-xl text-primary mb-2">
                  {method.title}
                </h3>

                {/* Description */}
                <p className="font-body text-sm text-muted-foreground mb-4 flex-grow">
                  {method.description}
                </p>

                {/* Value */}
                <div className="font-body font-semibold text-base text-foreground mb-4">
                  {method.value}
                </div>

                {/* Availability & Response Time */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center space-x-2">
                    <Icon name="ClockIcon" size={16} className="text-brand-secondary" />
                    <span className="text-xs font-body text-muted-foreground">{method.availability}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Icon name="BoltIcon" size={16} className="text-conversion-accent" />
                    <span className="text-xs font-body text-muted-foreground">Response: {method.responseTime}</span>
                  </div>
                </div>

                {/* Action Button */}
                <button className="w-full px-4 py-2.5 bg-brand-primary hover:bg-brand-primary/90 text-white rounded-lg font-cta font-semibold text-sm transition-all duration-300 transform hover:scale-105">
                  {method.action}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}